"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = void 0;
require("./permission");
require("./error");
require("normalize.css");
require("element-ui/lib/theme-chalk/index.css");
require("@/styles/tailwind.css");
require("@/request");
var _antDesignVue = _interopRequireDefault(require("@form-create/ant-design-vue"));
var _antDesignVue2 = _interopRequireDefault(require("ant-design-vue"));
var _elementUi = _interopRequireDefault(require("element-ui"));
var _moment = _interopRequireDefault(require("moment"));
var _vcolorpicker = _interopRequireDefault(require("vcolorpicker"));
var _vue = _interopRequireDefault(require("vue"));
var _website = _interopRequireDefault(require("@/config/website"));
var _permission2 = _interopRequireDefault(require("@/core/directives/permission"));
var _router = _interopRequireDefault(require("@/router"));
var _store = _interopRequireDefault(require("@/store"));
var _App = _interopRequireDefault(require("./App"));
var _bootstrap = _interopRequireDefault(require("@/core/bootstrap"));
require("./styles/common.scss");
require("ant-design-vue/dist/antd.less");
require("@/assets/styles/global.less");
var _plugins = _interopRequireDefault(require("@/plugins"));
var _utils = _interopRequireDefault(require("@ys/utils"));
require("@/components/index");
require("@ys/micro-components");
var _ui = _interopRequireDefault(require("@ys/ui"));
// 权限
// 日志

_vue.default.use(_vcolorpicker.default);
_vue.default.config.productionTip = false;
_vue.default.prototype.$moment = _moment.default;
_vue.default.use(_router.default);
_vue.default.use(_permission2.default);
_vue.default.use(_elementUi.default);
_vue.default.use(_antDesignVue2.default);
_vue.default.use(_antDesignVue.default);
_vue.default.config.devtools = process.env.NODE_ENV !== 'production';
(0, _bootstrap.default)();

// 加载website
_vue.default.prototype.website = _website.default;

// global style

// 注册全局插件

_vue.default.use(_plugins.default);
_vue.default.use(_utils.default);

// 注册全局组件 实现自动动态 require 组件，无需手动添加

_vue.default.use(_ui.default);
_vue.default.config.productionTip = false;
const init = async () => {
  if (_store.default.getters.accessToken) {
    await Promise.all([_store.default.dispatch('GetMenuList'), _store.default.dispatch('getRoleInfo')]);
  }
  const app = new _vue.default({
    router: _router.default,
    store: _store.default,
    render: h => h(_App.default)
  });
  app.$mount('#app');
};
exports.init = init;
init();